export function createClassModuleFactory(loader, exportName = 'default') {

    if (typeof loader !== 'function')
        throw new Error('[createClassModuleFactory] "loader" must be a function.');

    return async (app, routeDef, routeMatch) => {
        const moduleFile = await loader();
        const ModuleClass = moduleFile?.[exportName] ?? null;

        if (!ModuleClass)
            throw new Error(`[createClassModuleFactory] Export "${exportName}" not found for route "${routeDef?.name ?? '?'}".`);

        return new ModuleClass(null, Object.assign({}, routeDef?.options ?? {}, {
            app,
        }));
    };

}

export function createDataModelModuleFactory(moduleLoader, modelLoader, exportName = 'default') {

    if (typeof moduleLoader !== 'function')
        throw new Error('[createDataModelModuleFactory] "moduleLoader" must be a function.');
    if (typeof modelLoader !== 'function')
        throw new Error('[createDataModelModuleFactory] "modelLoader" must be a function.');

    return async (app, routeDef, routeMatch) => {

        const [moduleFile, modelFile] = await Promise.all([
            moduleLoader(),
            modelLoader(),
        ]);

        const ModuleClass = moduleFile?.[exportName] ?? moduleFile?.default ?? null;
        const ModelClass = modelFile?.default ?? Object.values(modelFile ?? {})[0] ?? null;

        if (!ModuleClass)
            throw new Error(`[createDataModelModuleFactory] Export "${exportName}" not found for route "${routeDef?.name ?? '?'}".`);
        if (typeof ModelClass !== 'function')
            throw new Error(`[createDataModelModuleFactory] Model class not found for route "${routeDef?.name ?? '?'}".`);

        const authManager = app?.authManager ?? null;
        if (!authManager)
            throw new Error(`[createDataModelModuleFactory] Application authManager is required for route "${routeDef?.name ?? '?'}".`);

        const dataModel = ModelClass.getInstance(authManager);
        if (typeof app.prepareDataModel === 'function')
            await app.prepareDataModel(dataModel);
        else
            await dataModel.prepare();

        return new ModuleClass(null, Object.assign({}, routeDef?.options ?? {}, {
            app,
            dataModel,
        }));

    };

}
